import { useState } from 'react';
import { ReactSVG } from 'react-svg';
// import Link from 'next/link';
import Image from 'next/image';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { Button, ButtonsContainer } from '@forma/forma-ui-kit';
import PageBlock from '@/components/PageBlock';
import Video from '@/components/Video';
import RequestDemoModal2 from '@/components/blocks/RequestDemoModal2';
import RequestDemoModal3 from '@/components/blocks/RequestDemoModal3';
import { analytics } from '@/helpers/analytics';

import styles from './video-banner-2.module.css';

// const lkUrl = process.env.LK_URL;

const VideoBanner2 = ({ video, notice, callModal }) => {
  const { t } = useTranslation();
  // const { lang } = useContext(ThemeContext);
  const [isRequestOpen, setRequestOpen] = useState(false);
  const [isShowVideo, setShowVideo] = useState(false);
  const [isRequest3Open, setRequest3Open] = useState(false);

  return (
    <PageBlock variant="white" className={styles.root} title="Управляйте документами на едином сервисе быстро и безопасно">
      <div className={styles.subtitle}>
        Создавайте, согласовывайте и подписывайте документы в 10 раз быстрее, сводя к минимуму ошибки и затраты времени.
      </div>
      <div className={styles.videoWrap}>
        {isShowVideo ? (
          <Video className={styles.video} src={video} autoPlay />
        ) : (
          <Image
            src="/images/screen-filling.webp"
            className={styles.video}
            width={1146}
            height={577}
            alt=""
          />
        )}
        {!isShowVideo && (
          <div className={styles.videoOverlay}>
            <Button
              viewStyle="secondary"
              className={classNames(styles.button, styles.secondary, styles.playButton)}
              onClick={() => setShowVideo(true)}
              icon={<ReactSVG src="/icons/play-2.svg" className={styles.playIcon} />}
            >
              {t('watch_video')}
            </Button>
          </div>
        )}
      </div>
      <ButtonsContainer className={styles.buttons}>
        <Button
          // as={Link}
          viewStyle="primary"
          className={styles.button}
          onClick={() => setRequest3Open(true)}
        // href={`${lkUrl}/register?lng=${lang}`}
        >
          {callModal?.button ?? t('start_free')}
        </Button>
        <Button
          // as={Link}
          viewStyle="secondary"
          className={classNames(styles.button, styles.secondary)}
          onClick={() => {
            setRequestOpen(true);
            analytics.clickTryTrial();
          }}
        // href="/request"
        >
          {t('request_demo')}
        </Button>
      </ButtonsContainer>
      <div className={styles.notice}>
        {notice}
      </div>
      <RequestDemoModal2
        open={isRequestOpen}
        onClose={setRequestOpen}
      />
      <RequestDemoModal3
        open={isRequest3Open}
        onClose={setRequest3Open}
        title={callModal?.title}
        description={callModal?.description}
      />
    </PageBlock>
  );
};

export default VideoBanner2;
